import React from "react";
import SEO from "components/SEO/SEO";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faPhoneAlt, faClock, faEnvelope, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import "./Contact.css";

const CONTACT_CARDS = [
  {
    icon: faMapMarkerAlt, title: "Address",
    content: <>
      <strong>CSR Associates</strong><br />
      No 67, 1st Floor, 5th Cross,<br />
      3rd Main Road, Chamrajpete,<br />
      Bengaluru, Karnataka — 560018
    </>
  },
  {
    icon: faPhoneAlt, title: "Contact",
    content: <>
      <a href="tel:+9108026601556">080 2660 1556</a><br />
      <a href="mailto:csrassociates2012@gmail.com">Email : csrassociates2012@gmail.com</a><br />
      </>
  },
  {
    icon: faClock, title: "Business Hours",
    content: <>Monday – Saturday<br />9:00 AM – 7:00 PM IST<br /><br />Sunday: Closed</>
  },
  {
    icon: faShieldAlt, title: "RBI Sachet Portal",
    content: <>
      Report grievances against financial service providers.<br /><br />
      <a href="https://sachet.rbi.org.in/" target="_blank" rel="noopener noreferrer"
        style={{ color: "var(--gold)", fontWeight: 600 }}>
        Visit sachet.rbi.org.in →
      </a>
    </>
  },
];

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact CSR Associates | Debt Recovery & BPO Enquiry Bangalore"
        description="Contact CSR Associates for debt recovery and BPO services. Located in Chamrajpete Bengaluru. Mon-Sat 9AM-7PM. Call +91 90083 28891."
        keywords="contact CSR Associates, debt recovery bangalore contact, BPO services enquiry bangalore"
      />
      <div className="contact-page">
        <div className="container" style={{ maxWidth: 1200, margin: "0 auto", padding: "80px 24px" }}>

          <div className="page-hero" data-aos="fade-up">
            <span className="page-hero-tag">Get in Touch</span>
            <h1 className="page-hero-title">
              Business <em>Enquiry</em>
            </h1>
            <p className="page-hero-sub">
              Reach out to explore how CSR Associates can serve your debt recovery and outsourcing needs.
              We respond within one business day.
            </p>
            <div className="page-hero-divider" />
          </div>

          {/* Info Cards */}
          <div className="contact-cards-grid" data-aos="fade-up">
            {CONTACT_CARDS.map(({ icon, title, content }, i) => (
              <div key={i} className="contact-info-card" data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="contact-icon-wrap">
                  <FontAwesomeIcon icon={icon} />
                </div>
                <h3>{title}</h3>
                <div className="contact-card-content">{content}</div>
              </div>
            ))}
          </div>

          {/* Write to us */}
          <div className="contact-cta-card" data-aos="zoom-in">
            <div className="contact-cta-icon">✉️</div>
            <h2>Write to Us</h2>
            <p>For business enquiries, partnership opportunities, or job applications — drop us an email and we'll get back to you promptly.</p>
            <div className="contact-cta-actions">
              <a href="mailto:csrassociates2012@gmail.com?subject=Business%20Enquiry%20via%20Website" className="btn-gold">
                Send Business Enquiry 
              </a>
              <a
                href="https://wa.me/919008328891?text=Hello%2C%20I%27d%20like%20to%20enquire%20about%20CSR%20Associates%20services."
                target="_blank" rel="noopener noreferrer"
                className="btn-outline-gold"
              >
                WhatsApp Us
              </a>
            </div>
          </div>

          {/* Map */}
          <div data-aos="fade-up">
            <div className="eyebrow">Find Us</div>
            <h2 className="section-heading" style={{ marginBottom: "24px" }}>
              Our <span className="accent">Location</span>
            </h2>
            <div className="map-container">
              <iframe
                title="CSR Associates Location — Chamrajpet Bengaluru Karnataka"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7776.418862603313!2d77.56000933778591!3d12.958446455069408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae154a7f3c3baf%3A0xfe14e2fd60693362!2sCSR%20Associates!5e0!3m2!1sen!2sin!4v1760665342597!5m2!1sen!2sin"
                width="100%" height="420" style={{ border: 0 }}
                allowFullScreen="" loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
